import { useRef, useState, useEffect, useCallback } from 'react';
//Redux
import { useAppDispatch, useObjectSelector } from '@redux/store';
import { fetchData } from '@redux/slices/functionals/request/requestActions';

import Timeline from '@components/Utils/Timeline';
import { useSetState } from 'react-use';
import { requestActions } from '@redux/slices/functionals/request/requestSlice';
import { CElement, ILocationHistory } from '@ts/ui-models';

interface TimelineItem {
  id: string | number;
  title: string;
  description: string;
  timestamp: string;
  createAt: string;
}

interface ILocationHistoryProp {
  values: CElement;
}

const LocationHistoryTab = (props: ILocationHistoryProp) => {
  const dispatch = useAppDispatch();
  const tElement = props.values;
  const [timelineItems, setTimelineItems] = useState<TimelineItem[]>([]);
  const refCanMoreFetch = useRef(true);

  const {
    data: locationHistory,
    loading,
    error,
  }: { data: ILocationHistory; loading: boolean; error: any } = useObjectSelector(state => state.request['locationHistory']);
  const [pagination, setPagination] = useSetState({
    page: 0,
    offset: 0,
    size: 10,
  });

  //#region Handlers
  const handleEndScroll = useCallback(() => {
    if (refCanMoreFetch.current) {
      setTimeout(() => {
        setPagination(prevPagination => {
          if (!loading) {
            return {
              page: prevPagination.page + 1,
              offset: (prevPagination.page + 1) * prevPagination.size,
            };
          } else {
            return prevPagination;
          }
        });
      }, 300);
    }
  }, [refCanMoreFetch, loading]);
  //#endregion

  //#region Functions
  const transformLocationHistoryToTimelineItems = () => {
    const items: TimelineItem[] = [];

    locationHistory?.rows.map(row => {
      items.push({
        id: row.logicalId,
        title: row.location.name,
        description: '',
        timestamp: row.aliveStart,
        createAt: row.aliveStart,
      });
    });
    setTimelineItems([...timelineItems, ...items]);
  };
  const getLocationHistory = () => {
    //TODO: Move to services
    dispatch(
      fetchData({
        key: 'locationHistory',
        url: `/api/v2/item/${tElement?.getID()}/locationHistory`,
        dataBody: { offset: pagination.offset, limit: pagination.size },
      })
    );
  };
  //#endregion

  //#region Effects
  const effectLoadAndDestroyLocationHistory = (deps: React.DependencyList) => {
    useEffect(() => {
      getLocationHistory();
      return () => {
        dispatch(requestActions.cleanKey('locationHistory'));
      };
    }, deps);
  };
  const effectAfterLoadLocationHistory = (deps: React.DependencyList) => {
    useEffect(() => {
      if (locationHistory) {
        if (locationHistory.rows.length === 0) {
          refCanMoreFetch.current = false;
        } else {
          if (locationHistory.rows.length <= pagination.size) {
            refCanMoreFetch.current = false;
          }
          transformLocationHistoryToTimelineItems();
        }
      }
    }, deps);
  };

  //#endregion

  effectLoadAndDestroyLocationHistory([dispatch, pagination]);
  effectAfterLoadLocationHistory([locationHistory]);

  return (
    <Timeline
      listTimeline={timelineItems}
      loading={loading}
      canMoreFetch={refCanMoreFetch.current}
      onChangeEndScroll={handleEndScroll}
    />
  );
};

export default LocationHistoryTab;
